export default "__VITE_ASSET__D$vQLR1J__"